// Box Elevation options
// Elevation/Bottom/Lvl_1
export const elevationBottomLvl1 = '0 2px 4px rgba(75, 75, 75, 0.04)';
// Elevation/Bottom/Lvl_2
export const elevationBottomLvl2 = '0 3px 5px rgba(66, 66, 66, 0.1)';
// Elevation/Bottom/Lvl_3
export const elevationBottomLvl3 = '0 3px 15px rgba(64, 64, 64, 0.12)';
// Elevation/Bottom/Lvl_4
export const elevationBottomLvl4 = '0 2px 8px rgba(0, 0, 0, 0.32)';
// Elevation/Top/Lvl_2
export const elevationTopLvl2 = '0 -3px 5px rgba(66, 66, 66, 0.1)';
// Elevation/Top/Lvl_4
export const elevationTopLvl4 = '0 -10px 30px rgba(57, 57, 57, 0.1)';
// Extra constants
export const typographyTextShadow = '0 0 95px rgba(0, 0, 0, 0.07)';
export const promotionalBannerShadow = '54.402px 48.278px 38.419px 0px rgba(0, 0, 0, 0.06), 37.865px 33.603px 24.848px 0px rgba(0, 0, 0, 0.05), 24.834px 22.039px 15.419px 0px rgba(0, 0, 0, 0.04), 14.959px 13.275px 9.262px 0px rgba(0, 0, 0, 0.04), 7.889px 7.001px 5.511px 0px rgba(0, 0, 0, 0.03), 3.272px 2.904px 3.295px 0px rgba(0, 0, 0, 0.02), 0.76px 0.674px 1.748px 0px rgba(0, 0, 0, 0.01);';
